<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="唯一代码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'code',
              { rules: [{ required: true, message: '请输入唯一代码' }] }
            ]"
            placeholder="请输入唯一代码"
          ></a-input>
        </a-form-item>
        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入标题' }] }
            ]"
            placeholder="请输入标题"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="微信公众号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'wechatAppId',
              { rules: [{ required: true, message: '请选择微信公众号' }] }
            ]"
            placeholder="请选择微信公众号"
            @change="getTemplate"
          >
            <a-select-option
              v-for="item in wechatList"
              :key="item.id"
              :value="item.appId"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="模板ID"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'wechatTemplate',
              { rules: [{ required: true, message: '请选择微信模板ID' }] }
            ]"
            placeholder="请选择微信模板ID"
          >
            <a-select-option
              v-for="item in wechatTemplateList"
              :key="item.id"
              :value="item.templateId"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { ajaxGetDictItems } from '@/api/api';
import { getAction, httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';

export default {
  name: 'UserBlacklistModal',
  components: {
    JDate
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        wechatAppList:
          process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType',
        wechatTemplateList:
          process.env.VUE_APP_CMS_WECHAT + '/msgTemplate/list',
        add: process.env.VUE_APP_CMS_CUSTOMER + '/user/trade/notice/add',
        edit: process.env.VUE_APP_CMS_CUSTOMER + '/user/trade/notice/edit'
      },
      dictOptions: [],
      wechatList: [],
      wechatTemplateList: []
    };
  },
  created() {
    getAction(this.url.wechatAppList, { type: '1,2' }).then(res => {
      if (res.success && res.result) {
        this.wechatList = res.result;
      }
    });
  },
  methods: {
    getTemplate(appId) {
      getAction(this.url.wechatTemplateList, { appId: appId }).then(res => {
        if (res.success && res.result) {
          this.wechatTemplateList = res.result;
        }
      });
    },
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'code', 'name', 'wechatAppId', 'wechatTemplate')
        );
      });
      if (record.wechatAppId) {
        this.getTemplate(record.wechatAppId);
      }
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          for (let index in this.wechatTemplateList) {
            let item = this.wechatTemplateList[index];
            if (item.templateId == formData.wechatTemplate) {
              formData.templateContent = item.content;
              formData.templateMapper = item.data;
              break;
            }
          }
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(row, 'code', 'name', 'wechatAppId', 'wechatTemplate')
      );
    }
  }
};
</script>
